export enum DocumentType {
  contract = 'contract',
  policy = 'policy',
  employeeDocument = 'employee_document',
  complianceDocument = 'compliance_document',
  legalDocument = 'legal_document',
  financialDocument = 'financial_document',
  vendorDocument = 'vendor_document',
  trainingMaterial = 'training_material',
  other = 'other',
}

export enum DocumentStatus {
  draft = 'draft',
  active = 'active',
  archived = 'archived',
  expired = 'expired',
  pendingReview = 'pending_review',
}

export interface Document {
  id: string;
  name: string;
  description?: string;
  type: DocumentType;
  status: DocumentStatus;
  fileUrl: string;
  fileName: string;
  fileSize: number; // in bytes
  mimeType: string;
  category?: string;
  tags: string[];
  
  // Ownership and access
  ownerId: string;
  ownerName: string;
  createdBy: string;
  createdByName: string;
  
  // Versioning
  version: number;
  parentDocumentId?: string; // For versioning
  isLatestVersion: boolean;
  
  // Expiration and review
  expiresAt?: Date;
  reviewDate?: Date;
  lastReviewedAt?: Date;
  lastReviewedBy?: string;
  
  // Metadata
  relatedEntityType?: string; // 'employee', 'vendor', 'contract', etc.
  relatedEntityId?: string;
  metadata?: Record<string, unknown>;
  
  // Access control
  isPublic: boolean;
  allowedRoles?: string[];
  allowedUserIds?: string[];
  
  createdAt: Date;
  updatedAt: Date;
  lastAccessedAt?: Date;
  accessCount: number;
}

export interface DocumentTemplate {
  id: string;
  name: string;
  description?: string;
  type: DocumentType;
  templateContent: string; // HTML or markdown
  variables: string[]; // Template variables like {{employeeName}}
  category?: string;
  isActive: boolean;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface DocumentFolder {
  id: string;
  name: string;
  description?: string;
  parentFolderId?: string;
  path: string; // Full path like "/HR/Employee Documents"
  ownerId: string;
  isPublic: boolean;
  allowedRoles?: string[];
  documentCount: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface DocumentAccessLog {
  id: string;
  documentId: string;
  userId: string;
  userName: string;
  action: 'view' | 'download' | 'edit' | 'delete' | 'share';
  ipAddress?: string;
  userAgent?: string;
  timestamp: Date;
}

